import { firebase, googleAuthProvider, db } from '../../firebase/fbConfig';
import { push } from 'connected-react-router';

export const emailSignup = (authObject) => {
  return (dispatch) => {
    firebase
      .auth()
      .createUserWithEmailAndPassword(authObject.email, authObject.password)
      .then(() => {
        dispatch(push(`/setup/`));
      })
      .catch((error) => {
        dispatch(signupError(error));
      });
  };
};

export const emailSignupInviteLawyer = (authObject) => {
  return (dispatch) => {
    firebase
      .auth()
      .createUserWithEmailAndPassword(authObject.email, authObject.password)
      .then((id) => {
        db.collection('lawyer')
          .doc(id.user.uid)
          .set(
            {
              email: authObject.email,
              lawyerID: id.user.uid,
              userType: 'lawyer',
              accountCreated: new Date(),
            },
            { merge: true }
          )
          .then(() => {
            db.collection('lawyer')
              .doc(id.user.uid)
              .collection('cases')
              .doc(authObject.caseID)
              .set(
                {
                  caseID: authObject.caseID,
                  clientID: authObject.id,
                  lawyerAssigned: new Date(),
                  lawyerID: id.user.uid,
                },
                { merge: true }
              )
              .then(() => {
                dispatch(push(`/case/${authObject.caseID}`));
              });
          });
      })
      .catch((error) => {
        dispatch(signupError(error));
      });
  };
};

export const signupError = (error) => ({
  type: 'SIGNUP_ERROR',
  error,
});

export const emailSignIn = (credentials) => {
  return (dispatch) => {
    firebase
      .auth()
      .signInWithEmailAndPassword(credentials.email, credentials.password)
      .then(() => {
        dispatch(push('/cases'));
      })
      .catch((error) => {
        dispatch(SignError(error));
      });
  };
};

export const SignError = (error) => ({
  type: 'SIGNIN_ERROR',
  error,
});

export const loginError = (error) => ({
  type: 'LOGIN_ERROR',
  error,
});

export const passwordReset = (emailAddress) => {
  var auth = firebase.auth();
  auth
    .sendPasswordResetEmail(emailAddress)
    .then(() => {
      console.log('Reset email sent');
    })
    .catch((error) => {
      console.log('Error: ' + error);
    });
};

export const startGoogleLogin = () => {
  return (dispatch) => {
    return firebase
      .auth()
      .signInWithPopup(googleAuthProvider)
      .then(() => {
        dispatch(push('/cases'));
      });
  };
};

export const login = (user = {}) => ({
  type: 'LOGIN',
  user,
});

export const startLogout = () => {
  return (dispatch) => {
    return firebase
      .auth()
      .signOut()
      .then(() => {
        dispatch(push('/pages'));
      })
      .then(() => {
        dispatch(logout());
      })
      .then(() => {
        window.location.reload();
      });
  };
};

export const logout = () => ({ type: 'LOGOUT' });
